// @core/api/endpoints/task/get_task_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskPolicyResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task policy
 * Returns a task policy by ID.
 */
export async function GetTaskPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<TaskPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<TaskPolicyResponse>(requestPath, { ...requestOptions });
}
